import styled from 'styled-components'

import { CssUnit } from '@/types'
import { breakpoints, colors, fontSizes } from '@/styles'
import { toUnit } from '@/utils/styles'
import { Label } from '@/components/form'

const Wrapper = styled.div`
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const ModalText = styled.p<{ bottom?: CssUnit }>`
  text-align: center;
  margin: 0;
  font-size: ${fontSizes.regular};
  color: ${colors.mediumGrey};
  ${props => props.bottom && `margin-bottom: ${toUnit(props.bottom)}`}
`
const ButtonWrapper = styled.div`
  padding-top: 20px;
  width: 100%;
  > button,
  > a {
    width: 100%;
  }
`
const ModalTopper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 26px;
  gap: 16px;
  background: ${colors.grey96};
  width: 100%;
`
const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 32px;
  text-align: center;
  gap: 16px;
`
const BlinkingDot = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background: ${colors.red72};
  animation: blink 2s infinite;
  position: absolute;
  z-index: 11;
  left: -6px;
  top: -6px;
  @keyframes blink {
    0%,
    100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
`
const ModalRow = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  width: fit-content;
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    flex-direction: row;
  }
`
const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const ToggleLabel = styled(Label)<{ left?: boolean }>`
  margin-right: ${props => (props.left ? '0' : '15px')};
  margin-left: ${props => (props.left ? '15px' : '0')};
  margin-bottom: 0;
  font-size: 16px;
  font-weight: 400;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding-left: 0 !important;
  }
`

const Title = styled.span`
  font-size: 24px;
  font-weight: 700;
`

const Subtitle = styled.span`
  font-size: 20px;
  font-weight: 400;
`
export {
  Wrapper,
  ModalText,
  ButtonWrapper,
  ModalTopper,
  ModalContent,
  BlinkingDot,
  ModalRow,
  ImageWrapper,
  ToggleLabel,
  Title,
  Subtitle
}
